export default "__VITE_ASSET__BmfcbmFw__"